export default __webpack_public_path__ + "static/media/img3.47b149b1.jpg";